export const REPLAY_COLLECTION_DRAG_TYPE =
  'application/x-terra-replay-collection';

export function insertItemBeforeId<T extends { id: string }>({
  items,
  itemId,
  beforeId,
}: {
  items: ReadonlyArray<T>;
  itemId: string;
  beforeId?: string;
}): T[] {
  const item = items.find((entry) => entry.id === itemId);

  if (!item) {
    return [...items];
  }

  const without = items.filter((entry) => entry.id !== itemId);

  if (!beforeId) {
    return [...without, item];
  }

  const insertAt = without.findIndex((entry) => entry.id === beforeId);

  if (insertAt === -1) {
    return [...without, item];
  }

  return [...without.slice(0, insertAt), item, ...without.slice(insertAt)];
}

export function moveReplaySession<
  T extends { id: string; collectionId: string },
>({
  sessions,
  sessionId,
  collectionId,
  beforeSessionId,
}: {
  sessions: ReadonlyArray<T>;
  sessionId: string;
  collectionId: string;
  beforeSessionId?: string;
}): T[] {
  const session = sessions.find((entry) => entry.id === sessionId);

  if (!session) {
    return [...sessions];
  }

  if (session.collectionId === collectionId && beforeSessionId === undefined) {
    return [...sessions];
  }

  const withCollection = sessions.map((entry) =>
    entry.id === sessionId ? { ...entry, collectionId } : entry,
  );

  return insertItemBeforeId({
    items: withCollection,
    itemId: sessionId,
    beforeId: beforeSessionId,
  });
}
